import {
  EXO_SKELETON_RUNTIME_SCOPE,
  EXO_SKELETON_EVENT_NAMES,
  type ExoSkeletonEventNames,
} from './consts';
import { RemoteInfo } from './remote/runtime';

export { getExoSkeletonRemotesUrl } from './helpers/getExoSkeletonRemotesUrl';
export { wrapWithEventPropertiesPrefix } from './wrapWithEventPropertiesPrefix';
export { safeStringify } from './safeStringify';
export { toError } from './toError';

export interface RuntimeRemoteInfo extends RemoteInfo {
  /**
   * Returns the remote info from the ExoSkeleton host
   * @returns {Promise<RemoteInfo>}
   * @deprecated
   * @example
   *
   * const remoteInfo = await get();
   * console.log(remoteInfo);
   * // { scope: 'my-scope', url: 'https://assets.my-scope.acc.autodesk.com/assets-no-cache/remoteEntry.js' }
   */
  get(): Promise<RemoteInfo>;
  override: boolean;
  moniker?: string;
  /**
   * Indicates if the remote is a bridge remote
   */
  isBridge?: boolean;
}

export interface ExoSkeletonRuntime {
  available?: boolean;
  remotes?: Record<string, RuntimeRemoteInfo>;
  listeners?: ExoSkeletonEventNames[];
}

declare global {
  interface Window {
    [EXO_SKELETON_RUNTIME_SCOPE]?: ExoSkeletonRuntime;
  }
}

export function getExoSkeletonRuntime(host: Window | WindowProxy = window) {
  if (!host[EXO_SKELETON_RUNTIME_SCOPE]) {
    host[EXO_SKELETON_RUNTIME_SCOPE] = {};
  }

  return host[EXO_SKELETON_RUNTIME_SCOPE];
}

/**
 * Should be used by an ExoSkeleton host
 */
export function setIsInExoSkeleton() {
  const runtime = getExoSkeletonRuntime();

  runtime.available = true;
}

export function createUniqueRequestId(prefix = '') {
  return `${prefix}${Math.random().toString(16).slice(2)}`;
}

export function getRemoteRuntime(scope: string) {
  const runtime = getExoSkeletonRuntime();
  return runtime?.remotes?.[scope];
}

export function removeExoSkeletonRuntime() {
  delete window[EXO_SKELETON_RUNTIME_SCOPE];
}

export { EXO_SKELETON_EVENT_NAMES };
